const pako = require("pako");

export default class Utils {}

Utils.compressString = function (string) {
	const compressed = pako.deflate(string);
	const compressedString = compressed.toString();
	return compressedString;
};